import { DEFAULT_SKYBOX_AUDIO_SRC } from './SkyboxAudioPlayer.jsx';

// 1. Define Enums to prevent typos
export const TIME_OF_DAY = {
    MORNING: 'Morning',
    EVENING: 'Evening'
};

export const SEASON = {
    SPRING: 'Spring',
    AUTUMN: 'Autumn',
};

// --- NEW: Add the View Mode enum ---
export const VIEW_MODE = {
    PEDESTRIAN: 'Pedestrian',
    BIRD: 'Drone',
    BIKE: 'Cyclist'
};

// --- NEW: Define your global special-mode videos (Update URLs as needed) ---
export const v_Drone = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Flythrough_Drone/EFS_Flythrough_Drone.m3u8";
export const v_Cyclist = "https://ofofanam.myhostpoint.ch/tribschenstrasse//260709/Flythrough_Bike_360/TS_ESF_360Test.m3u8";
export const a_Drone = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_Flythrough_Drone.mp3";
export const a_Cyclist = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_Flythrough_Bike.mp3";

export class SceneMedia {
    constructor(locId, viewMode, time, season, videoSrc, audioSrc, initialHeading) {
        this.id = `${locId}_${viewMode}_${season}_${time}`; 
        this.locId = locId;
        this.title = time;
        this.time = time;
        this.season = season;
        this.viewMode = viewMode; 
        this.videoSrc = videoSrc;
        this.audioSrc = audioSrc;
        this.initialHeading = initialHeading;
    }
}

// Dummy URLs (Replace with your actual 36 video URLs)
export const v_EFS_BAE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldB/AE/EFS_BAE.m3u8";
export const v_EFS_BAM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldB/AM/EFS_BAM.m3u8";
export const v_EFS_BSE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldB/SE/EFS_BSE.m3u8";
export const v_EFS_BSM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldB/SM/EFS_BSM.m3u8";

export const v_EFS_CAE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldC/AE/EFS_CAE.m3u8";
export const v_EFS_CAM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldC/AM/EFS_CAM.m3u8";
export const v_EFS_CSE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldC/SE/EFS_CSE.m3u8";
export const v_EFS_CSM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/EisfeldC/SM/EFS_CSM.m3u8";

export const a_EFS_BAE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_BAE.mp3";
export const a_EFS_BAM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_BAM.mp3";
export const a_EFS_BSE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_BSE.mp3";
export const a_EFS_BSM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_BSM.mp3";

export const a_EFS_CAE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_CAE.mp3";
export const a_EFS_CAM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_CAM.mp3";
export const a_EFS_CSE = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_CSE.mp3";
export const a_EFS_CSM = "https://ofofanam.myhostpoint.ch/tribschenstrasse/260709/Audio/TS_EFS_CSM.mp3";


// 3. The Nested Configuration Matrix
export const LOCATION_CONFIG = {
    "eisfeldB": {
        id: "eisfeldB",
        top: "50%",
        left: "64%",
        defaultTime: TIME_OF_DAY.MORNING,
        defaultSeason: SEASON.SPRING,
        media: {
            [VIEW_MODE.PEDESTRIAN]: {
                [SEASON.SPRING]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.MORNING, SEASON.SPRING, v_EFS_BSM, a_EFS_BSM, 0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.EVENING, SEASON.SPRING, v_EFS_BSE, a_EFS_BSE, 0),
                },
                [SEASON.AUTUMN]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_EFS_BAM, a_EFS_BAM,0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_EFS_BAE, a_EFS_BAE,0),
                }
            },
            [VIEW_MODE.BIRD]: {
                [SEASON.SPRING]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.BIRD, TIME_OF_DAY.MORNING, SEASON.SPRING, v_Drone, a_Drone, 0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.BIRD, TIME_OF_DAY.EVENING, SEASON.SPRING, v_Drone, a_Drone, 0),
                },
                [SEASON.AUTUMN]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.BIRD, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_Drone, a_Drone, 0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.BIRD, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_Drone, a_Drone, 0),
                }
            },
            [VIEW_MODE.BIKE]: {
                [SEASON.SPRING]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.BIKE, TIME_OF_DAY.MORNING, SEASON.SPRING, v_Cyclist, a_Cyclist, Math.PI/2),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.BIKE, TIME_OF_DAY.EVENING, SEASON.SPRING, v_Cyclist, a_Cyclist, Math.PI/2),
                },
                [SEASON.AUTUMN]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldB", VIEW_MODE.BIKE, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_Cyclist, a_Cyclist, Math.PI/2),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldB", VIEW_MODE.BIKE, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_Cyclist, a_Cyclist, Math.PI/2),
                }
            }
        }
    },
   
    "eisfeldC": {
        id: "eisfeldC",
        top: "53.5%",
        left: "67.94%",
        defaultTime: TIME_OF_DAY.MORNING,
        defaultSeason: SEASON.SPRING,
        media: {
            [VIEW_MODE.PEDESTRIAN]: {
                [SEASON.SPRING]: {
                [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.MORNING, SEASON.SPRING, v_EFS_CSM, a_EFS_CSM, 0),
                [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.EVENING, SEASON.SPRING, v_EFS_CSE, a_EFS_CSE, 0),
                },
                [SEASON.AUTUMN]: {
                [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_EFS_CAM, a_EFS_CAM, 0),
                [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.PEDESTRIAN, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_EFS_CAE, a_EFS_CAE, 0),
                }
            },
            [VIEW_MODE.BIRD]: {
                [SEASON.SPRING]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.BIRD, TIME_OF_DAY.MORNING, SEASON.SPRING, v_Drone, a_Drone, 0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.BIRD, TIME_OF_DAY.EVENING, SEASON.SPRING, v_Drone, a_Drone, 0),
                },
                [SEASON.AUTUMN]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.BIRD, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_Drone, a_Drone, 0),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.BIRD, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_Drone, a_Drone, 0),
                }
            },
            [VIEW_MODE.BIKE]: {
                [SEASON.SPRING]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.BIKE, TIME_OF_DAY.MORNING, SEASON.SPRING, v_Cyclist, a_Cyclist, Math.PI/2),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.BIKE, TIME_OF_DAY.EVENING, SEASON.SPRING, v_Cyclist, a_Cyclist, Math.PI/2),
                },
                [SEASON.AUTUMN]: {
                    [TIME_OF_DAY.MORNING]: new SceneMedia("eisfeldC", VIEW_MODE.BIKE, TIME_OF_DAY.MORNING, SEASON.AUTUMN, v_Cyclist, a_Cyclist, Math.PI/2),
                    [TIME_OF_DAY.EVENING]: new SceneMedia("eisfeldC", VIEW_MODE.BIKE, TIME_OF_DAY.EVENING, SEASON.AUTUMN, v_Cyclist, a_Cyclist, Math.PI/2),
                }
            }
        }
    },
};

// 4. Exports required by UI.jsx
export const LOCATION_LIST = Object.values(LOCATION_CONFIG);

// Safely grab the very first video to use as the app's default startup media
export const DEFAULT_SCENE_MEDIA = LOCATION_CONFIG["eisfeldB"].media[VIEW_MODE.PEDESTRIAN][SEASON.SPRING][TIME_OF_DAY.MORNING];
export const DEFAULT_FADE_DURATION_MS = 2000;
export const MAP_IMAGE_SRC = "/images/ui/T_Perimeter_3200x800.png";